import { Component, EventEmitter, Input, Output } from '@angular/core'
import { LayerGroupInfo, LayerGroupReference } from '../layer-groups.model'

@Component({
    selector: 'app-layer-group-title',
    templateUrl: './layer-group-title.component.html',
    styleUrls: ['./layer-group-title.component.scss'],
})
export class LayerGroupTitleComponent {
    @Input() groupInfo: LayerGroupInfo
    @Input() showShowAllButton = false
    @Input() showHideAllButton = false
    @Input() showToggleAllButton = true
    @Input() showManageLayersButton = false
    @Input() manageLayersDisabled = false
    @Input() listOpen = false

    @Output() selectLayerGroup = new EventEmitter<LayerGroupReference>()
    @Output() showAllLayers = new EventEmitter<{ groupId: string }>()
    @Output() hideAllLayers = new EventEmitter<{ groupId: string }>()
    @Output() manageLayers = new EventEmitter<{ groupId: string }>()
    @Output() toggleLayerGroup = new EventEmitter<void>()

    selectLayerGroupClicked(elementId: string): void {
        this.selectLayerGroup.emit({
            groupName: this.groupInfo.name,
            groupId: this.groupInfo.id,
            elementId,
        })
    }

    showAllLayersClicked(event: MouseEvent): void {
        event.stopPropagation()
        this.showAllLayers.emit({ groupId: this.groupInfo.id || this.groupInfo.name })
    }

    hideAllLayersClicked(event: MouseEvent): void {
        event.stopPropagation()
        this.hideAllLayers.emit({ groupId: this.groupInfo.id || this.groupInfo.name })
    }

    manageLayersClicked(event: MouseEvent): void {
        event.stopPropagation()
        if (this.manageLayersDisabled || !this.groupInfo.id) {
            return
        }
        this.manageLayers.emit({ groupId: this.groupInfo.id })
    }

    toggleLayerGroupClicked(event: MouseEvent): void {
        event.stopPropagation()
        this.toggleLayerGroup.emit()
    }
}
